"use client"

import { styled } from "styled-components"

export const SnackbarRoot = styled.div`
  --init-translate-y: -200px;
  transform: translateY(var(--init-translate-y));
  transition-duration: var(--animation-duration-long);
  position: absolute;
  z-index: var(--z-index-toast);
  top: 0;
  display: flex;
  align-items: stretch;
  transition-property: opacity, transform;
  width: 100%;
  z-index: 9999;
`

export const SnackbarWrapper = styled.div`
  width: calc(
    100% - var(--app-horizontal-padding) - var(--app-horizontal-padding)
  );
  margin: 0 auto;

  border-radius: 8px;
  background: var(--Schemes-Surface-Surface-Container-Lowest, #fff);
  box-shadow: 2px 2px 12px 0 rgba(0, 0, 0, 0.16),
    0 1px 6px 0 rgba(28, 31, 33, 0.06);
  padding: var(--spacing_m, 12px) var(--spacing_l, 16px);

  display: flex;
  gap: 8px;
  align-items: center;

  .adm-notice-bar-content {
    justify-content: flex-start;
  }

  a {
    color: var(
      --Schemes-Primary-container-Primary-Container-Variant-2,
      #0fbdd4
    );
    font-size: 14px;
    font-weight: 600;
    text-decoration: none;
  }
`

export const SnackbarTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
`
